export type Fiber = any;

export const enum TrackType {
    click = 'click',
    jump = 'jump',
    custom = 'custom',
}

export interface TrackReportBaseInfo {
    // 类型
    k_track_type?: TrackType;

    // 层级信息
    k_track_0?: string;
    k_track_1?: string;
    k_track_2?: string;
    k_track_3?: string;
    k_track_4?: string;
    k_track_5?: string;
    k_track_6?: string;
    k_track_7?: string;
    k_track_8?: string;

    // 层级聚合
    k_track_msg?: string;

    // 触发节点信息
    k_track_e?: string;

    // 触发节点的html 信息
    k_track_html?: string;

    // url 专属
    k_track_to_url?: string;
    k_track_to_path?: string;

    // 当前顶部模块
    k_top_menu?: string;

    // 当前侧边模块
    k_sider_menu?: string;
}

export interface ITrackReportInfo extends TrackReportBaseInfo {}

export type OnRecordCallback = (info: ITrackReportInfo) => void;

export interface ITrackReportBase {
    compName?: string;
    trackInfo?: string | (() => string);
}

export interface ITrackReport extends ITrackReportBase {}

export interface ITrackReportRoot extends ITrackReportBase {
    onReport?: (info: TrackReportBaseInfo) => void;
}
